import { useEffect, type RefObject } from 'react';
import { handleSpatialKey } from '../lib/spatialNav';

/** While `active`, arrow keys move focus between controls inside the referenced element. */
export function useSpatialNav(ref: RefObject<HTMLElement | null>, active: boolean): void {
  useEffect(() => {
    if (!active) return;
    const onKey = (e: KeyboardEvent) => {
      if (ref.current) handleSpatialKey(e, ref.current);
    };
    // Capture phase so it runs before the slideshow's own arrow-key shortcuts.
    window.addEventListener('keydown', onKey, true);
    return () => window.removeEventListener('keydown', onKey, true);
  }, [ref, active]);
}
